"use client";

import { useEffect, useState } from "react";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/next";
import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import { setAnalyticsConsent } from "@/lib/analytics";
import { MesureDesPages } from "./MesureDesPages";

const KEY = "expedys_consent";
type Choice = "granted" | "denied" | null;

export function ConsentManager() {
  const t = useTranslations("consent");
  const [choice, setChoice] = useState<Choice>(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let stored: Choice = null;
    try {
      stored = localStorage.getItem(KEY) as Choice;
    } catch {
      /* localStorage indisponible */
    }
    if (stored === "granted") setAnalyticsConsent(true);
    setChoice(stored);
    setReady(true);
  }, []);

  const decide = (value: "granted" | "denied") => {
    try {
      localStorage.setItem(KEY, value);
    } catch {
      /* no-op */
    }
    setAnalyticsConsent(value === "granted");
    setChoice(value);
  };

  return (
    <>
      {choice === "granted" && (
        <>
          <Analytics />
          <SpeedInsights />
          <MesureDesPages />
        </>
      )}

      {ready && choice === null && (
        <div className="fixed inset-x-0 bottom-0 z-[300] px-4 pb-4">
          <div className="mx-auto flex max-w-[640px] flex-col gap-3 rounded-card-lg border border-line bg-white p-5 shadow-[0_24px_60px_-24px_rgba(40,20,8,.4)] sm:flex-row sm:items-center">
            <p className="flex-1 text-[13.5px] leading-[1.5] text-ink">
              {t("text")}{" "}
              <Link
                href={{ pathname: "/legal", query: { tab: "privacy" } }}
                className="font-semibold text-terracotta underline-offset-2 hover:underline"
              >
                {t("learnMore")}
              </Link>
            </p>
            <div className="flex flex-none gap-2.5">
              <button
                onClick={() => decide("denied")}
                className="rounded-btn border border-line-strong bg-white px-4 py-2.5 text-sm font-bold text-espresso transition hover:bg-cream-soft"
              >
                {t("refuse")}
              </button>
              <button
                onClick={() => decide("granted")}
                className="rounded-btn bg-gradient-cta px-4 py-2.5 text-sm font-bold text-white transition hover:-translate-y-0.5"
              >
                {t("accept")}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
